import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy } from '../../services/locations'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from "react-helmet-async";
import moment from "moment"

import { Modal } from '../UI'

const Affiliate = ({ match, history }) => {

    const { data, authServices, eventServices, setAppState, location } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const [ loading, setLoading ] = useState(false)
    const [ signingOut, setSigningOut ] = useState(false)
    const [ dashboard, setDashboard ] = useState({})

    const loadDashboard = () => {
        setLoading(true)
        authServices.affiliates().then(res => {
            setDashboard(res)
            setLoading(false)
        }).catch(res => {
            setLoading(false)
            if(res.status == 404) history.push("/page-not-found")
            if(res.status == 500) history.push("/server-error")
        })
    }

    useEffect(() => {
        if(isReady) loadDashboard()
    }, [isReady])

    const contestSignUp = doSignUp => {
        setSigningOut(true)
        const type = doSignUp ? 'contest-sign-up' : 'contest-sign-out'
        eventServices.fire(app.user.id, 'App\\User', type, true).then(res => {
            authServices.user().then(res => {
                setAppState('app.user', res.user)
                setSigningOut(false)
            })
        }).catch(res => {
            setSigningOut(false)
            if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
        })
    }

    const title = "Rewards program"
    const promoUrl = app && app.user && app.user.promo_url ? app.user.promo_url : null
    const promoCode = app && app.user && app.user.promo_code ? app.user.promo_code : null

    const isSignedUp = app && app.user && app.user.contest && app.user.contest.type == 'contest-sign-up'

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel', 'close'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['sign-out'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <h1>{title}</h1>

                        {promoUrl &&
                            <div className="lead mb-3">
                                <div className="row">
                                    <div className="col-lg-6">
                                        Your promotion link: <a href={promoUrl} className="font-weight-bold">{promoUrl}</a>
                                    </div>
                                    <div className="col-lg-3">
                                        Promo code: <b className="font-weight-bold">{promoCode}</b>
                                    </div>
                                    <div className="col-lg-3 text-right">
                                        <span className="">Status: {isSignedUp ? 'Signed-Up' : 'Signed-Out'}</span>
                                        {!isSignedUp &&
                                            <Fragment>
                                                <br />
                                                <a href="" className="btn btn-sm btn-primary" onClick={e => {
                                                    e.preventDefault()
                                                    contestSignUp(true)
                                                }}>Sign-In for rewards program</a>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <p className="mb-3">
                            Sign-Up for the rewards program and share adsitepro.com website with everyone looking to buy, sell or find services and earn credits for your sign ups, their posts & your posts! <a href={process.env.MIX_APP_URL + "/article/affiliate-program"}>Learn more</a>
                        </p>


                        {loading &&
                            <div className="text-center my-5">
                                <FontAwesomeIcon icon={faSpinner} />
                            </div>
                        }

                        {!loading && dashboard.data &&
                            <Fragment>
                                <div className="row row-eq-height mb-4">
                                    <div className="col-lg-4 col-xl-4 mb-3">
                                        <div className="card h-100">
                                            <div className="card-body">
                                                <h5 className="card-title text-muted text-center font-weight-bold">Affiliates</h5>
                                                <p className="text-center">Total activated affiliate users.</p>
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.activated_within_state}</div>
                                                        <small>Within state</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.activated_outside_state}</div>
                                                        <small>Outside state</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.activated_outside_country}</div>
                                                        <small>Outside country</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-xl-4 mb-3">
                                        <div className="card h-100">
                                            <div className="card-body">
                                                <h5 className="card-title text-muted text-center font-weight-bold">Posts Within State</h5>
                                                <p className="text-center">Personal and affiliate posts inside your state.</p>
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.posts_within_state}</div>
                                                        <small>Personal posts</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.a_posts_within_state}</div>
                                                        <small>Affiliate posts</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.t_posts_within_state}</div>
                                                        <small>Total</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-xl-4 mb-3">
                                        <div className="card h-100">
                                            <div className="card-body">
                                                <h5 className="card-title text-muted text-center font-weight-bold">Posts Outside State</h5>
                                                <p className="text-center">Personal and affiliate posts outside your state.</p>
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.posts_outside_state}</div>
                                                        <small>Personal posts</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.a_posts_outside_state}</div>
                                                        <small>Affiliate posts</small>
                                                    </div>
                                                    <div className="text-center">
                                                        <div style={{fontSize: '2.25rem'}}>{dashboard.data.t_posts_outside_state}</div>
                                                        <small>Total</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {dashboard.months && dashboard.months.filter(item => item.data.activated > 0 || item.data.posts > 0) &&
                                    <Fragment>
                                        <h2>Months</h2>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered bg-white">
                                                <thead>
                                                    <tr>
                                                        <th>Month</th>
                                                        <th className="text-center">
                                                            <a href={process.env.MIX_APP_URL + '/article/affiliate-program'}>(#1)</a><br />
                                                            Affiliates Within State
                                                        </th>
                                                        <th className="text-center">
                                                            <a href={process.env.MIX_APP_URL + '/article/affiliate-program'}>(#2)</a><br />
                                                            Posts Within State
                                                        </th>
                                                        <th className="text-center">
                                                            <a href={process.env.MIX_APP_URL + '/article/affiliate-program'}>(#3)</a><br />
                                                            Affiliates Outside State
                                                        </th>
                                                        <th className="text-center">
                                                            <a href={process.env.MIX_APP_URL + '/article/affiliate-program'}>(#4)</a><br />
                                                            Posts Outside State
                                                        </th>
                                                        <th className="text-center">
                                                            <a href={process.env.MIX_APP_URL + '/article/affiliate-program'}>(#5)</a><br />
                                                            Affiliates Outside Country
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dashboard.months.filter(item =>
                                                        item.data.activated_within_state > 0 ||
                                                        item.data.activated_outside_state > 0 ||
                                                        item.data.activated_outside_country > 0 ||
                                                        item.data.t_posts_within_state > 0 ||
                                                        item.data.t_posts_outside_state > 0
                                                    ).map(item =>
                                                        <tr key={item.key}>
                                                            <td>{item.name}</td>
                                                            <td className="text-center">{item.data.activated_within_state}</td>
                                                            <td className="text-center">{item.data.t_posts_within_state}</td>
                                                            <td className="text-center">{item.data.activated_outside_state}</td>
                                                            <td className="text-center">{item.data.t_posts_outside_state}</td>
                                                            <td className="text-center">{item.data.activated_outside_country}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Fragment>
                                }
                            </Fragment>
                        }

                        {app && app.user && app.user.contest &&
                            <Fragment>
                                <hr />
                                {!isSignedUp &&
                                    <p>
                                        <span>You signed-out on {moment(app.user.contest.created_at).format('MM/DD/YYYY hh:mm a')}</span>
                                    </p>
                                }
                            </Fragment>
                        }

                    </div>
                </main>
            </div>
            <Footer />
            <Modal {...dialogOptions} show={showDialog} />
        </Fragment>
    )
}

export default Affiliate
